// @flow

import React from 'react';

import { useState } from 'react';
import Tray from './tray';
import type { Props as TrayProps } from './tray';

function ManagedTray(props: TrayProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Tray
      expanded={expanded}
      onExpandChange={() => setExpanded(!expanded)}
      {...props}
    >
      {props.children}
    </Tray>
  );
}

ManagedTray.defaultProps = Tray.defaultProps;

export default ManagedTray;
